module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageNotFound":"Страница не найдена"}}')
  delete Component.options._Ctor
}
